import { useEffect, useState, useCallback } from "react";
import vaultService, { COMPARTMENT } from "../lib/vault/vaultService";

/**
 * Reactive vault state. Rerenders when the vault locks/unlocks.
 *
 *   const { state, unlockPin, lock, save, load } = useVault();
 */
export function useVault() {
  const [tick, setTick] = useState(0);
  const [initialized, setInitialized] = useState(null);
  const [bioAvail, setBioAvail] = useState(false);
  const [bioEnrolled, setBioEnrolled] = useState(false);

  const refresh = useCallback(async () => {
    setInitialized(await vaultService.isInitialized());
    setBioAvail(await vaultService.biometricAvailable());
    setBioEnrolled(await vaultService.biometricEnrolled());
  }, []);

  useEffect(() => {
    refresh();
    return vaultService.subscribe(() => { setTick((t) => t + 1); refresh(); });
  }, [refresh]);

  return {
    tick,
    initialized,                                 // null=loading, true/false
    unlocked: vaultService.isUnlocked(),
    biometricAvailable: bioAvail,
    biometricEnrolled: bioEnrolled,
    bootstrap: (pin, opts) => vaultService.bootstrap(pin, opts),
    unlockPin: (pin)       => vaultService.unlockWithPin(pin),
    unlockBio: ()          => vaultService.unlockWithBiometric(),
    lock:      ()          => vaultService.lock(),
    load:      (id)        => vaultService.loadCompartment(id),
    save:      (id, obj)   => vaultService.saveCompartment(id, obj),
    enrollBio: ()          => vaultService.enrollBiometric(),
    removeBio: ()          => vaultService.removeBiometric(),
    getHint:   ()          => vaultService.getHint(),
    exportBackup: ()       => vaultService.exportBackup(),
    importBackup: (b, pin) => vaultService.importBackup(b, pin),
    wipe:      ()          => vaultService.wipe(),
  };
}

export { COMPARTMENT };
